// extracted by mini-css-extract-plugin
export var closeButton = "_mn-2";
export var closeButtonIcon = "_mn-3";
export var lightboxContent = "_mn-1";
export var lightboxOverlay = "_mn-0";